module.exports = __webpack_public_path__ + "assets/271f634f77070b3ee64cc843475af263.mp3";